if (!customElements.get('producer-gallery')) {
  class ProducerGallery extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.swiper = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.producer-gallery__arrow--next',
          prevEl: '.producer-gallery__arrow--prev',
        },
      });
    }
  }
  customElements.define('producer-gallery', ProducerGallery);
}
